'use client';

import { useTranslations } from 'next-intl';
import { HoloCard } from './HoloCard';

interface InvalidStateProps {
  code: string;
}

export function InvalidState({ code }: InvalidStateProps) {
  const t = useTranslations('public');

  return (
    <div className="flex flex-col gap-3 px-4" style={{ paddingBottom: 100 }}>
      {/* HoloCard flips to reveal red "not found" */}
      <HoloCard flipIn variant="red" />

      {/* Main card — fades in after flip */}
      <div
        className="pub-card flex flex-col items-center text-center gap-3 pub-reveal pub-reveal-1"
        style={{ padding: '24px 20px' }}
      >
        {/* Red X icon */}
        <div
          className="flex items-center justify-center"
          style={{
            width: 56,
            height: 56,
            borderRadius: 16,
            background: 'var(--pub-red-dim)',
            border: '1px solid rgba(239,68,68,0.3)',
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="var(--pub-red)" strokeWidth="2.5" width="24" height="24">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </div>

        {/* Title */}
        <h1
          style={{
            fontFamily: 'var(--font-pub-display)',
            fontSize: 20,
            fontWeight: 700,
            color: 'var(--pub-text-primary)',
          }}
        >
          {t('invalid.title')}
        </h1>

        {/* Code pill */}
        <span
          style={{
            fontFamily: 'var(--font-pub-mono)',
            fontSize: 12,
            color: 'var(--pub-red)',
            background: 'var(--pub-red-dim)',
            border: '1px solid rgba(239,68,68,0.2)',
            padding: '5px 16px',
            borderRadius: 100,
            letterSpacing: '0.1em',
          }}
        >
          {code}
        </span>

        {/* Body */}
        <p
          style={{
            fontSize: 13,
            color: 'var(--pub-text-secondary)',
            lineHeight: 1.6,
            maxWidth: 280,
          }}
        >
          {t('invalid.body')}
        </p>

        {/* Reasons box */}
        <div
          className="w-full text-left"
          style={{
            background: 'var(--pub-surface-3)',
            border: '1px solid var(--pub-border)',
            borderRadius: 14,
            padding: '14px 16px',
          }}
        >
          <div
            style={{
              fontFamily: 'var(--font-pub-mono)',
              fontSize: 10,
              color: 'var(--pub-text-muted)',
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              marginBottom: 10,
            }}
          >
            {t('invalid.reasonsTitle')}
          </div>
          <div
            style={{
              fontSize: 12,
              color: 'var(--pub-text-secondary)',
              lineHeight: 1.9,
            }}
          >
            &bull; {t('invalid.reason1')}<br />
            &bull; {t('invalid.reason2')}<br />
            &bull; {t('invalid.reason3')}<br />
            &bull; {t('invalid.reason4')}
          </div>
        </div>
      </div>

      {/* CTAs */}
      <div className="pub-reveal pub-reveal-2 flex flex-col gap-3">
        <button className="pub-btn pub-btn-primary">{t('invalid.scanAgain')}</button>
        <a href={`/contact?reason=report-suspicious&code=${encodeURIComponent(code)}`} className="pub-btn pub-btn-danger" style={{ textAlign: 'center', textDecoration: 'none', display: 'block' }}>{t('invalid.reportSeller')}</a>
        <a href={`/contact?reason=support&code=${encodeURIComponent(code)}`} className="pub-btn pub-btn-secondary" style={{ textAlign: 'center', textDecoration: 'none', display: 'block' }}>{t('invalid.contactUs')}</a>
      </div>
    </div>
  );
}
